// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.picker {
    margin: 5px 0px;
}

.hexStack {
    padding: 4px;
}

.hexBlock {
    width: 85px;
}

.rgbBlock {
    width: 45px;
    margin-right: 5px;
}

`, "",{"version":3,"sources":["webpack://./src/app/components/controls/gradientpicker/colorpicker.control.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB","sourcesContent":[".picker {\n    margin: 5px 0px;\n}\n\n.hexStack {\n    padding: 4px;\n}\n\n.hexBlock {\n    width: 85px;\n}\n\n.rgbBlock {\n    width: 45px;\n    margin-right: 5px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
